"use client";

import { useEffect, useState } from "react";
import { captureReferralFromUrl, readReferralCode } from "@/lib/referral-capture";

/**
 * Captures a `?invite=<code>` from the current URL (first-touch) and returns the
 * currently held referral code for display (e.g. an "invited by a friend" note).
 *
 * Reads `window.location.search` in an effect rather than `useSearchParams()` on
 * purpose — `useSearchParams()` suspends during streaming SSR and would stall the
 * HTML response (see the PageTracker note in CLAUDE.md).
 */
export function useCaptureReferral(): string | null {
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    captureReferralFromUrl(window.location.search);
    setCode(readReferralCode());
  }, []);

  return code;
}
